import { useEffect } from 'react'
import { Toaster, toast as showToast } from 'sonner'
import { type Toast } from '#app/utils/toast.server.ts'

/**
 * Prototype pill toast: ink pill, bottom-centre. Error toasts turn red.
 * Client code can call `toast('Saved')` / `toast.error('…')` from 'sonner' directly.
 */
export function EpicToaster({ toast }: { toast?: Toast | null }) {
	return (
		<>
			<Toaster
				position="bottom-center"
				gap={8}
				toastOptions={{
					unstyled: true,
					classNames: {
						toast:
							'flex items-center gap-3 rounded-full bg-ink px-[18px] py-3 text-sm text-paper shadow-[0_12px_32px_rgba(27,25,21,.25)] font-sans',
						error: '!bg-bad !text-white',
						title: 'font-normal',
						description: 'text-paper/70 text-[13px]',
						actionButton: 'ml-2 rounded-full bg-paper px-3 py-1 text-xs text-ink',
						cancelButton: 'ml-1 text-xs text-paper/70',
						closeButton: 'hidden',
					},
				}}
			/>
			{toast ? <ShowToast toast={toast} /> : null}
		</>
	)
}

function ShowToast({ toast }: { toast: Toast }) {
	const { id, type, title, description } = toast
	useEffect(() => {
		setTimeout(() => {
			showToast[type](title, { id, description })
		}, 0)
	}, [description, id, title, type])
	return null
}
